import { createContext, useContext } from 'react'

interface TreeContextValue {
  onToggleExpand: (nodeId: string) => void
  onMultiSelectNode: (nodeId: string, checked: boolean) => void
}

export const TreeContext = createContext<TreeContextValue | null>(null)

export const useTreeContext = () => {
  const context = useContext(TreeContext)

  if (!context) {
    throw new Error('useTreeContext must be used within TreeContext.Provider')
  }

  return context
}
